import React from "react";
import { Form } from "@formio/react";
import "./Builder.css";
function CustomForm({
  formData,
  onSubmitHandler,
  formName,
  closeModal,
  initialValues,
  readOnly,
}) {
  return (
    <div>
      <div styleName="header">
        {formName}
        {closeModal && <div styleName="close" onClick={closeModal} />}
      </div>
      <div styleName="form-container" style={{ paddingTop: "10px" }}>
        {formData && (
          <Form
            submission={initialValues}
            form={formData}
            onSubmit={onSubmitHandler}
            options={{ readOnly: readOnly }}
          />
        )}
      </div>
    </div>
  );
}

export default CustomForm;
